import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BidRate, BidRateModHistory, QueryResult, RateSummary, Transaction} from "@app/shared";
import {Observable} from "rxjs";

@Injectable()
export class RateService {

  constructor(private http: HttpClient) {
  }

  getRateSummaries(transaction: Transaction, refId: number, year?: string, accountingPeriodId?: number, ignoreFiscalYearCostPoolException?: boolean): Observable<RateSummary[]> {
    let url = `/indirect-rate/summary?transaction=${transaction}&refId=${refId}`;
    if (year) {
      url = url + `&year=${year}`;
    }
    if (accountingPeriodId) {
      url = url + `&accountingPeriodId=${accountingPeriodId}`;
    }
    // Making an explicit null check to avoid parameter being excluded if the value is false.
    if (ignoreFiscalYearCostPoolException != null) {
      url = url + `&ignoreFiscalYearCostPoolException=${ignoreFiscalYearCostPoolException}`;
    }

    return this.http.get<RateSummary[]>(url);
  }

  getBidRates(transaction: Transaction, refId: number): Observable<BidRate[]> {
    let url = `/indirect-rate/bid-rates?transaction=${transaction}&refId=${refId}`;
    return this.http.get<BidRate[]>(url);
  }

  saveOrUpdateBidRates(rateSummaries: RateSummary []): Observable<RateSummary[]> {
    let url = `/indirect-rate/bid-rates`;
    return this.http.post<RateSummary[]>(url, rateSummaries);
  }

  // Duplicating this to prevent dependencies on non-shared services
  getContractMods(contractId: number): Observable<QueryResult> {
    let url = "/contract/modifications/search?contract.id=" + contractId;
    return this.http.get<QueryResult>(url);
  }

  getContractModsForBid(bidId: number): Observable<QueryResult> {
    let url = "/contract/modifications/search?contract.contractBid.id=" + bidId;
    return this.http.get<QueryResult>(url);
  }

  getBidRateModHistory(bidRateId: number): Observable<BidRateModHistory[]> {
    let url = `/indirect-rate/bid-rates/${bidRateId}/history`;
    return this.http.get<BidRateModHistory[]>(url);
  }

  populateBidRatesForContract(contractId: number): Observable<BidRate[]> {
    let url = `/indirect-rate/contract/${contractId}/generate`;
    return this.http.put<BidRate[]>(url, null);
  }
}
